import { createApiRef } from '@backstage/core-plugin-api';

import { ElementPath, TrackingData } from '../types';

export interface TrackingActions {
  navigate: true;
  dismiss: true;
  create: true;
  update: true;
  delete: true;
  'open-dialog': true;
  expand: true;
  collapse: true;
  copy: true;
}

export type Action = keyof TrackingActions extends never
  ? string
  : keyof TrackingActions & string;

// Declaration-merging seed: plugins register their page IDs by augmenting this
// interface from their tracking.d.ts files. It must start empty — PageId falls
// back to `string` only while no augmentations exist.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface TrackingPages {}

export type PageId = keyof TrackingPages extends never
  ? string
  : keyof TrackingPages & string;

export interface Interaction {
  elementPath: ElementPath;
  type: 'click' | 'hover' | 'double-click' | 'scroll' | 'keypress';
  action: Action;
  data: TrackingData;
}

export interface Impression {
  elementPath: ElementPath;
  data: TrackingData;
}

export interface PageImpressionEvent {
  pageId: PageId;
  pageViewId: string;
  fromPageId: PageId | null;
  fromPageViewId: string | null;
  data: TrackingData;
}

export interface TourInteraction {
  action: 'start' | 'complete' | 'dismiss' | 'next';
  tourId: string;
  totalSteps: number;
  stepIndex?: number;
}

export interface TrackingApi {
  trackInteraction(interaction: Interaction): void;
  trackImpression(impression: Impression): void;
  trackPageImpression(event: PageImpressionEvent): void;
  trackTourInteraction(interaction: TourInteraction): void;
}

export const trackingApiRef = createApiRef<TrackingApi>({
  id: 'confidence.tracking',
});
